const config = {
  drawerWidth: 240,
  // urlStart: "/api/distribution",
  urlStart:"/api/distributiondevelop"
};
export default config;
